export const API_PATH_ApiAppPresetGet = '/services/app/presets/apiAppPresetGet';
